import { Component, OnInit } from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-datetime-field',
  templateUrl: './gelios-datetime-field.component.html',
})
export class GeliosDateTimeFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
}
